import React, { createContext, useContext, useReducer } from 'react';
import { wmsParamReducer } from '../reducer/wmsParamReducer';

const WmsParamContext = createContext({});

export const WmsParamProvider = ({ children }) => {
  const [state, dispatch] = useReducer(wmsParamReducer, {});

  const setWmsParam = (params) => {
    return dispatch({ type: 'SET', payload: params });
  };

  const getWmsParam = () => {
    return dispatch({ type: 'GET' });
  };

  const value = {
    wmsParams: state,
    setWmsParam,
    getWmsParam,
  };

  return <WmsParamContext.Provider value={value}>{children}</WmsParamContext.Provider>;
};

const useWmsParam = () => {
  return useContext(WmsParamContext);
};

export default useWmsParam;
